import React, { useMemo } from 'react'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'
import { Breadcrumbs } from 'flipper-ui'
import { getPaths } from '@core/lib/helpers'
import AppBarV2 from './AppBarV2'
import SidebarV2 from './SidebarV2'
import { BreadcrumbLink, SubHeader } from '@core/commonStyles'
import {
    LayoutV2ContentArea,
    LayoutV2RightColumn,
    LayoutV2Root
} from './styles'

interface IProps {
    children: ReactNode
}

const LayoutV2 = (props: IProps) => {
    const { t } = useTranslation()
    const location = useLocation()

    const pathMapping = useMemo(() => getPaths(t), [t])

    const linkWrapper = (link: string, label: string) => (
        <BreadcrumbLink key={link} to={link}>
            {label}
        </BreadcrumbLink>
    )

    return (
        <LayoutV2Root>
            <SidebarV2 />
            <LayoutV2RightColumn>
                <AppBarV2 />
                <LayoutV2ContentArea>
                    <SubHeader id='page-subheader'>
                        <Breadcrumbs
                            homeId='-'
                            pathMapping={pathMapping}
                            linkWrapper={linkWrapper}
                            pathname={location.pathname}
                        />
                    </SubHeader>
                    {props.children}
                </LayoutV2ContentArea>
            </LayoutV2RightColumn>
        </LayoutV2Root>
    )
}

export default LayoutV2
